import { apiClient } from '@/shared/services/api';
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

export interface SystemConfig {
    platformFeePercent: number;
    deliveryBaseFee: number;
    minimumOrderGlobal: number;
    updatedAt: { seconds: number; nanoseconds: number };
    updatedByAdminId: string;
    // Escalamiento
    orderEscalation?: {
        reNotifyMinutes: number;
        alertAdminMinutes: number;
        autoCancelMinutes: number;
    };
}

export interface GetConfigResponse {
    success: boolean;
    config: SystemConfig;
}

export interface UpdateConfigResponse {
    success: boolean;
    message: string;
}

/**
 * Obtiene la configuración global del sistema
 * Migrado a Firestore Directo
 */
export async function getSystemConfig(): Promise<SystemConfig> {
    try {
        const docRef = doc(db, 'system_config', 'global');
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
            console.warn("System config not found, returning defaults.");
            // Valores por defecto (espejo del backend)
            return {
                platformFeePercent: 15,
                deliveryBaseFee: 15,
                minimumOrderGlobal: 0,
                orderEscalation: {
                    reNotifyMinutes: 5,
                    alertAdminMinutes: 10,
                    autoCancelMinutes: 30
                },
                updatedAt: { seconds: Math.floor(Date.now() / 1000), nanoseconds: 0 },
                updatedByAdminId: "system"
            };
        }

        return docSnap.data() as SystemConfig;
    } catch (error) {
        console.error("Error obtaining system config:", error);
        throw error;
    }
}

/**
 * Actualiza la configuración global del sistema
 * Mantenemos la escritura en Backend por seguridad/auditoria
 */
export async function updateSystemConfig(data: Partial<SystemConfig>): Promise<void> {
    await apiClient.post<UpdateConfigResponse>('/updateSystemConfig', data);
}
